// extracted by mini-css-extract-plugin
module.exports = {"container":"stackWrapper_container__1dTKn","hoverLayer":"stackWrapper_hoverLayer__TNTXd"};